<div *ngIf="!fieldTemplate; else customTemplate" [id]="field.field + '_Item'" class="inputItem">
    <mat-form-field appearance="fill" floatLabel="always"
                    [color]="field.color" #item
                    [style.--background-hover]="hover$ | async" (click)="setCheckboxValue()">
        <mat-label [class]="field.field + '_Label'">{{field.label | translate}}</mat-label>
        <input autocomplete="off" matInput style="display: none" [formControl]="inputFormControl"/>
        <mat-checkbox [id]="field.field" [checked]="checked$ | async" [style.pointer-events]="field.readonly ? 'none' : 'inherit'"
            (keyup.space)="$event.preventDefault();$event.stopPropagation();setCheckboxValue()"
            (click)="$event.stopPropagation(); setCheckboxValue()">
        </mat-checkbox>
        <div matSuffix class="matSuffix">
            <button *ngIf="field.withClearButton" type="button" tabindex="-1" mat-icon-button (click)="$event.stopPropagation(); inputFormControl.patchValue('')">
                <mat-icon>close</mat-icon>
            </button>
            <mat-generic-input-slot [control]="inputFormControl" [field]="field" (hover)="hover$.next($event)"
                                    [fieldAddonTemplates]="fieldAddonTemplates$ | async"></mat-generic-input-slot>
        </div>
        <mat-error *ngIf="!(field.selectSearchData?.selectData?.options | async)?.length">
            <mat-generic-input-hint type="error" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
        </mat-error>
        <mat-hint>
            <mat-generic-input-hint type="combined" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
        </mat-hint>
    </mat-form-field>
    <mat-progress-bar class="loading" color="warning" mode="indeterminate"
                      *ngIf="(inputFormControl?.statusChanges | async) === 'PENDING' || inputFormControl?.status === 'PENDING'"></mat-progress-bar>
</div>
<ng-template #customTemplate>
    <ng-container *ngTemplateOutlet="fieldTemplate.template, context: { $implicit: field, genericInput: this, formControl: inputFormControl, index: index }"></ng-container>
</ng-template>
